import React, { useState, useEffect } from 'react'
import { Accordion } from 'react-bootstrap'
import AccordionToggle from './accordionToggle'

const AccordionSection = ({
  title,
  children,
  defaultActive,
  expandAccordion,
  readerText,
  hasTabs,
}) => {
  const [showonLoading, setShowLoading] = useState(true)
  useEffect(() => {
    let timer1 = setTimeout(() => setShowLoading(defaultActive || false), 1000)
    return () => {
      clearTimeout(timer1)
    }
  }, [])
  return (
    <Accordion
      defaultActiveKey={
        expandAccordion
          ? expandAccordion
          : hasTabs && showonLoading
          ? '0'
          : null
      }
    >
      <AccordionToggle
        readerText={readerText}
        eventKey="0"
        defaultActive={hasTabs && showonLoading}
        expandAccordion={expandAccordion}
        hasTabs={hasTabs}
      >
        {title}
      </AccordionToggle>

      <Accordion.Collapse eventKey="0" className="expandAccordion">
        <>{children}</>
      </Accordion.Collapse>
    </Accordion>
  )
}

export default AccordionSection
